import { Suspense } from 'react';
import { useSuspenseMaxRoutesQuery } from '#api/routes.queries.ts';
import { HeaderButtons } from '#components/patterns/header-buttons/HeaderButtons.tsx';
import { TableLayout } from '#components/patterns/layouts/table/TableLayout.tsx';
import { PageHeader } from '#components/patterns/page-header/PageHeader.tsx';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { EmptyRoutes } from '#screens/routes/empty/EmptyRoutes.tsx';
import { fromArray, Titled } from '#util/title.ts';
import { RoutesList } from '../list/RoutesList.tsx';

export function RoutesPage() {
  const {
    data: { data: routes },
    isFetching,
  } = useSuspenseMaxRoutesQuery();

  if (routes.length === 0) {
    return <EmptyRoutes />;
  }

  return (
    <Titled title={(title) => fromArray(['Routes', title])}>
      <TableLayout
        header={
          <PageHeader title="Routes" preventTitleWrap={true}>
            <HeaderButtons />
          </PageHeader>
        }
      >
        <Suspense fallback={<LoadingSpinner />}>
          <RoutesList data={routes} isFetching={isFetching} />
        </Suspense>
      </TableLayout>
    </Titled>
  );
}
